<template>
    <b-container>
        <div class="md-border d-none d-md-block"></div> 
        <b-row>
            <b-col class="mb-4" md="6" v-for="program in programs" :key="program.ProgramId">
            <a :href="program.ProgramPageUrl">
                <h2 class="program-name">{{program.Name}}</h2>
                <span  class="learn-more">{{learnMoreText}} <i class="fas fa-chevron-circle-right"></i></span>
            </a>
            <p>{{program.ProgramShortDescription}}</p>
            </b-col>
        </b-row>     
    </b-container>
</template>

<script>

export default {
  name: 'ProgramList',
  props: ['programs', 'learnMoreText']
}
</script>